export function getOperacaoCertificado(selected) {
    const funcao = selected?.funcao || 'Cadastrar';

    return {
        funcao,

        isCadastro: funcao === 'Cadastrar',

        isEdicao: funcao === 'Editar',

        isExclusao: funcao === 'Deletar',

        isTeste: funcao === 'Testar',
    };
}
